export const recs = {
  channel: {
    default: "9",
    desktop: "45",
    mobile: "9",
  },
};
